__turbopack_context__.v({
  "button": "textBlock-module-scss-module__zsN3nG__button",
  "center": "textBlock-module-scss-module__zsN3nG__center",
  "column": "textBlock-module-scss-module__zsN3nG__column",
  "copy": "textBlock-module-scss-module__zsN3nG__copy",
  "right": "textBlock-module-scss-module__zsN3nG__right",
  "textBlock": "textBlock-module-scss-module__zsN3nG__textBlock",
});
